module.exports = __webpack_public_path__ + "img/bg-saldo.7e013801.svg";